import { useEffect, useRef, useState } from "react";

const Reveal = ({
  children,
  as: Component = "div",
  variant = "fade-up",
  delay = 0,
  className = "",
}) => {
  const elementRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const el = elementRef.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.15, rootMargin: "0px 0px -32px 0px" }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []); // variant is stable — only run once per mount

  return (
    <Component
      ref={elementRef}
      className={`reveal reveal-${variant}${isVisible ? " is-visible" : ""}${className ? ` ${className}` : ""}`}
      style={delay ? { transitionDelay: `${delay}ms` } : undefined}
    >
      {children}
    </Component>
  );
};

export default Reveal;
